module.exports = __webpack_public_path__ + "img/i2.3317c113.png";